import { render, staticRenderFns } from "./ContextMenuBasic.vue?vue&type=template&id=fce25c80&scoped=true&"
import script from "./ContextMenuBasic.vue?vue&type=script&lang=js&"
export * from "./ContextMenuBasic.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuBasic.vue?vue&type=style&index=0&id=fce25c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce25c80",
  null
  
)

export default component.exports